import axios, { Axios, AxiosRequestConfig } from "axios";
import { APIResponse } from "./commonResponse";
import { adminAuthHeaders } from "../utils/adminAuth";

const client: Axios = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

//TODO: GET 메서드
export const getData = async <T>(
  url: string,
  config?: AxiosRequestConfig
): Promise<APIResponse<T>> => {
  try {
    const response = await client.get<APIResponse<T>>(url, config);
    return response.data;
  } catch (error: any) {
    throw new Error(error.message);
  }
};

//TODO: POST 메서드
export const postData = async <T>(
  url: string,
  data?: any,
  config?: AxiosRequestConfig
): Promise<APIResponse<T>> => {
  try {
    const response = await client.post<APIResponse<T>>(url, data, config);
    return response.data;
  } catch (error: any) {
    throw new Error(error.message);
  }
};

/** 관리자 토큰(Bearer)을 붙여 GET */
export const getAdminData = async <T>(
  url: string,
  config?: AxiosRequestConfig
): Promise<APIResponse<T>> => {
  return getData<T>(url, {
    ...config,
    headers: {
      ...config?.headers,
      ...adminAuthHeaders(),
    },
  });
};

/** 관리자 토큰(Bearer)을 붙여 POST */
export const postAdminData = async <T>(
  url: string,
  data?: unknown,
  config?: AxiosRequestConfig
): Promise<APIResponse<T>> => {
  return postData<T>(url, data, {
    ...config,
    headers: {
      ...config?.headers,
      ...adminAuthHeaders(),
    },
  });
};

/** 관리자 토큰(Bearer)을 붙여 PUT */
export const putAdminData = async <T>(
  url: string,
  data?: unknown,
  config?: AxiosRequestConfig
): Promise<APIResponse<T>> => {
  return putData<T>(url, data, {
    ...config,
    headers: {
      ...config?.headers,
      ...adminAuthHeaders(),
    },
  });
};

//TODO: PUT 메서드
export const putData = async <T>(
  url: string,
  data?: any,
  config?: AxiosRequestConfig
): Promise<APIResponse<T>> => {
  try {
    const response = await client.put<APIResponse<T>>(url, data, config);
    return response.data;
  } catch (error: any) {
    throw new Error(error.message);
  }
};

//TODO: PATCH 메서드
export const patchData = async <T>(
  url: string,
  data?: unknown,
  config?: AxiosRequestConfig
): Promise<APIResponse<T>> => {
  try {
    const response = await client.patch<APIResponse<T>>(url, data, config);
    return response.data;
  } catch (error: any) {
    throw new Error(error.message);
  }
};

/** 관리자 토큰(Bearer)을 붙여 PATCH */
export const patchAdminData = async <T>(
  url: string,
  data?: unknown,
  config?: AxiosRequestConfig
): Promise<APIResponse<T>> => {
  return patchData<T>(url, data, {
    ...config,
    headers: {
      ...config?.headers,
      ...adminAuthHeaders(),
    },
  });
};

//TODO: Delete 메서드
export const deleteData = async <T>(
  url: string,
  config?: AxiosRequestConfig
): Promise<APIResponse<T>> => {
  try {
    const response = await client.delete<APIResponse<T>>(url, config);
    return response.data;
  } catch (error: any) {
    throw new Error(error.message);
  }
};

/** 관리자 토큰(Bearer)을 붙여 DELETE */
export const deleteAdminData = async <T>(
  url: string,
  config?: AxiosRequestConfig
): Promise<APIResponse<T>> => {
  return deleteData<T>(url, {
    ...config,
    headers: {
      ...config?.headers,
      ...adminAuthHeaders(),
    },
  });
};
